import React, { memo } from 'react';

import { TableCell, TableHead, TableRow } from '@mui/material';
import TooltipedSortLabel from '@sharedCR/common/TooltipedSortLabel';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { HORIZONTAL_ALIGNMENT, TABLE_CELL_ALIGNMENT } from 'constants/ui';

import { SORT_LABEL_ALIGNMENT } from '../../../TooltipedSortLabel';
import HeadCell from '../../cells/HeadCell';

import { cellActionStyles } from './TableHeadContent.styles';

const TableHeadContent = ({
  onRequestSort,
  order,
  isActionColumn = false,
  columnsDefs,
  customRowStyles,
}) => (
  <TableHead>
    <TableRow className="h-48" sx={customRowStyles}>
      {columnsDefs.map(({ id, label, style, align, isSort = true }) => (
        <HeadCell
          align={!isSort ? align : TABLE_CELL_ALIGNMENT.INHERIT}
          customCellStyles={style}
          key={id}
        >
          <TooltipedSortLabel
            align={SORT_LABEL_ALIGNMENT[_.upperCase(align)]}
            id={id}
            isSort={isSort}
            label={label}
            order={order}
            onRequestSort={onRequestSort}
          />
        </HeadCell>
      ))}

      {isActionColumn && <TableCell style={cellActionStyles}>Action</TableCell>}
    </TableRow>
  </TableHead>
);

TableHeadContent.propTypes = {
  columnsDefs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
      isSort: PropTypes.bool,
      align: PropTypes.oneOf(Object.values(HORIZONTAL_ALIGNMENT)),
    }),
  ).isRequired,
  order: PropTypes.object,
  isActionColumn: PropTypes.bool,
  customRowStyles: PropTypes.object,
  onRequestSort: PropTypes.func,
};

export default memo(TableHeadContent);
